import { combineReducers } from 'redux';

import {
  DATA_TABLE_EL_CHANGED,
  FILTERS_CHANGED
} from '../constants/payoutManagerConstants';

const csrfToken = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const team = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const currentUser = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const dataTableTitle = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const dataTableDataSource = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const dataTableOrder = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const dataTableColumns = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const dataTableEl = (state = {}, action) => {
  switch (action.type) {
    case DATA_TABLE_EL_CHANGED:
      return action.el;
    default:
      return state;
  }
};

const filters = (state = [], action) => {
  switch (action.type) {
    case FILTERS_CHANGED:
      return action.filters;
    default:
      return state;
  }
};

const csvColumns = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const combinedCsvPath = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const recentPayouts = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const eventCsvPath = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const searchEventsPath = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const payoutManagerReducer = combineReducers({
  csrfToken,
  team,
  currentUser,
  dataTableTitle,
  dataTableDataSource,
  dataTableOrder,
  dataTableColumns,
  dataTableEl,
  filters,
  csvColumns,
  combinedCsvPath,
  recentPayouts,
  eventCsvPath,
  searchEventsPath
});

export default payoutManagerReducer;
